import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpRepo } from '@shared/services/httprepo';
import { ApiEndPointType } from '@shared/enums/common';

@Injectable({
  providedIn: 'root'
})

export class CompanyService {
  constructor(
    private httpRepo: HttpRepo
  ) {
  }

  public EditCompany(data: any): Observable<any> {
    return this.httpRepo.Put("", data, ApiEndPointType.FS, true);
  }

  public UploadCompanyLogo(formData) {
    return this.httpRepo.PostFile("logoimage", formData);
  }
}